import { supabase } from './supabase.js';

let cachedProfile = null;

export async function signIn(email, password) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
    cachedProfile = null;
    return data;
}

export async function signOut() {
    cachedProfile = null;
    return supabase.auth.signOut();
}

export async function getSession() {
    const { data } = await supabase.auth.getSession();
    return data.session;
}

export async function getProfile() {
    if (cachedProfile) return cachedProfile;
    const session = await getSession();
    if (!session) return null;

    const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single();

    if (error) {
        console.error('Profile load error:', error);
        return null;
    }
    cachedProfile = data;
    return data;
}

export function onAuthChange(callback) {
    return supabase.auth.onAuthStateChange((event, session) => {
        cachedProfile = null;
        callback(session, event);
    });
}

export async function isAdmin() {
    const profile = await getProfile();
    return profile?.role === 'admin';
}
